import {useEffect, useRef} from "react";

import {
    AmplitudeMapLayersLocation,
    getAmplitudeMapLayers,
    getAmplitudeMapRadius,
    trackAmplitudeMapLayersApplied
} from "../tracking/track_amplitude_map_layers_applied";
import {PoiType} from "../types/PoiType";

interface IProps {
    checkedPoiTypes: PoiType[];
    poiDistance: number;
    location: AmplitudeMapLayersLocation;
    itemId: number;
    propertyId?: number | null;
}

export const useMapLayersAppliedTracking = (props: IProps) => {
    const {checkedPoiTypes, poiDistance, location, itemId, propertyId} = props;

    const mapLayers = getAmplitudeMapLayers(checkedPoiTypes);
    const mapRadius = getAmplitudeMapRadius(poiDistance);
    const lastReportedRef = useRef<{contextKey: string; layersKey: string} | null>(null);

    useEffect(() => {
        const contextKey = `${location}::${itemId}::${propertyId ?? ""}`;
        const layersKey = `${mapLayers}::${mapRadius}`;
        const lastReported = lastReportedRef.current;

        if (lastReported?.contextKey === contextKey && lastReported.layersKey === layersKey) {
            return;
        }

        const filterTrigger = lastReported?.contextKey === contextKey ? "manual" : "automatic";
        lastReportedRef.current = {contextKey, layersKey};

        trackAmplitudeMapLayersApplied({
            filterTrigger,
            checkedPoiTypes,
            poiDistance,
            location,
            itemId,
            propertyId
        });
    }, [mapLayers, mapRadius, checkedPoiTypes, poiDistance, location, itemId, propertyId]);
};
import {useEffect, useRef} from "react";

import {
    AmplitudeMapLayersLocation,
    getAmplitudeMapLayers,
    getAmplitudeMapRadius,
    trackAmplitudeMapLayersApplied
} from "../tracking/track_amplitude_map_layers_applied";
import {PoiType} from "../types/PoiType";

interface IProps {
    checkedPoiTypes: PoiType[];
    poiDistance: number;
    location: AmplitudeMapLayersLocation;
    itemId: number;
    propertyId?: number | null;
}

export const useMapLayersAppliedTracking = (props: IProps) => {
    const {checkedPoiTypes, poiDistance, location, itemId, propertyId} = props;

    const mapLayers = getAmplitudeMapLayers(checkedPoiTypes);
    const mapRadius = getAmplitudeMapRadius(poiDistance);
    const lastReportedRef = useRef<{contextKey: string; layersKey: string} | null>(null);

    useEffect(() => {
        const contextKey = `${location}::${itemId}::${propertyId ?? ""}`;
        const layersKey = `${mapLayers}::${mapRadius}`;
        const lastReported = lastReportedRef.current;

        if (lastReported?.contextKey === contextKey && lastReported.layersKey === layersKey) {
            return;
        }

        const filterTrigger = lastReported?.contextKey === contextKey ? "manual" : "automatic";
        lastReportedRef.current = {contextKey, layersKey};

        trackAmplitudeMapLayersApplied({
            filterTrigger,
            checkedPoiTypes,
            poiDistance,
            location,
            itemId,
            propertyId
        });
    }, [mapLayers, mapRadius, checkedPoiTypes, poiDistance, location, itemId, propertyId]);
};
